import { useAuthStore } from "@/stores/auth";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

/** Gate admin routes: bounce to /admin/login when there is no JWT. */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const token = useAuthStore((s) => s.token);
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return <>{children}</>;
}
